module.exports = __webpack_public_path__ + "img/Quarter_Grey_Icon.6d9c08a8.png";